import store from '@/store'

import { computed } from '@vue/composition-api'

export default function useCalendarSidebar() {
  // ------------------------------------------------
  // calendarOptions
  // ------------------------------------------------
  const calendarOptions = computed(() => store.state['physician-duty'].calendarOptions)
  const serviceTypesOptions = computed(() => store.state['physician-duty'].serviceTypesOptions)

  // ------------------------------------------------
  // selectedCalendars
  // ------------------------------------------------
  const selectedCalendars = computed({
    get: () => store.state['physician-duty'].selectedCalendars,
    set: val => {
      store.commit('physician-duty/SET_SELECTED_EVENTS', val)
    },
  })

  const selectedDutyTypes = computed({
    get: () => store.state['physician-duty'].selectedDutyTypes,
    set: val => {
      store.commit('physician-duty/SET_SELECTED_SERVICE_TYPES', val)
    },
  })

  const currentPhysicians = computed({
    get: () => store.state['physician-duty'].currentPhysicians,
  })

  // ------------------------------------------------
  // checkAll
  // ------------------------------------------------
  const checkAll = computed({
    /*
      GET: Return boolean `true` => if length of options matches length of selected filters => Length matches when all events are selected
      SET: If value is `true` => then add all available options in selected filters => Select All
           Else if => all filters are selected (by checking length of both array) => Empty Selected array  => Deselect All
    */
    get: () => selectedCalendars.value.length === calendarOptions.value.length,
    set: val => {
      if (val) {
        selectedCalendars.value = calendarOptions.value.map(i => i.id)
      } else if (selectedCalendars.value.length === calendarOptions.value.length) {
        selectedCalendars.value = []
      }
    },
  })

  return {
    calendarOptions,
    serviceTypesOptions,
    selectedCalendars,
    selectedDutyTypes,
    currentPhysicians,
    checkAll,
  }
}
